import React from "react";

import "./title.scss";

const Title = (props) => {
  if (props.haveInnerHTML) {
    return (
      <h2
        className="home__title"
        dangerouslySetInnerHTML={{ __html: props.titulo }}
      ></h2>
    );
  }
  return <h2 className="home__title" dangerouslySetInnerHTML={{ __html: props.titulo }}></h2>;
};

export default Title;
